import React, { useEffect, useMemo, useState } from "react";
import { lib } from "../index";
import "./account.less";
import { Tabs, Tooltip, Space, Typography } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { BindRoleModal } from "./bind-role-modal";
import { USER_SUB_ROLE_LIST, WAITER_ROLE_LIST } from "./api";

function getMaxLevel(list) {
    let maxLevel = 1;

    function getNum(item, level = 0) {
        maxLevel = Math.max(maxLevel, level);
        item.num = 0;
        if (item.list && item.list.length > 0 && item.list[0].id) {
            item.list.map(child => {
                item.num += getNum(child, level + 1);
            });
        } else {
            item.num = 1;
        }
        return item.num;
    }

    getNum({ list });
    return maxLevel;
}

function AccountPermissionManage() {
    const allRole = "-1";
    let [detail, setDetail] = useState({});
    let [list, setList] = useState([]);
    let [roleGroup, setRoleGroup] = useState([]);
    let [accessData, setAccessData] = useState([]);
    const [roleIdList, setRoleIdList] = useState([]);
    let systemTarget = lib.config.webToken == "admin" ? "/ucenter-admin" : "/ucenter-customer";
    let systemCode = lib.config.systemCode;
    let maxLevel = getMaxLevel(list);

    const onChange = e => {
        if (e === allRole) {
            setRoleIdList(roleGroup.reduce((prev, curr) => [...prev, curr.id], []));
        } else {
            setRoleIdList([e]);
        }
    };

    useEffect(() => {
        getUserRoleList();
        getSystemInfo();
    }, []);

    useEffect(() => {
        if (roleIdList.length > 0) {
            getMenuList();
            fetchData();
        }
    }, [roleIdList]);
    const items = useMemo(() => {
        return roleGroup.length > 0
            ? [
                  {
                      key: allRole,
                      label: "全部",
                  },
                  ...roleGroup.map((item, index) => {
                      return {
                          key: item.id,
                          label: item.name,
                      };
                  }),
              ]
            : roleGroup.map((item, index) => {
                  return {
                      key: item.id,
                      label: item.name,
                  };
              });
    }, [roleGroup]);

    /**
     * 获取菜单权限
     */
    function getMenuList() {
        lib.request({
            url:
                lib.config.webToken === "admin"
                    ? "/ucenter-admin/waiter/menu/permission"
                    : "/ucenter-customer/user/sub/menu/permission",
            data: {
                systemCode,
                roleIdList,
            },
            needMask: true,
            success: list => {
                setList(list);
            },
        });
    }

    /**
     * 获取该用户的角色列表
     */
    const getUserRoleList = () => {
        lib.request({
            url: lib.config.webToken === "admin" ? WAITER_ROLE_LIST : USER_SUB_ROLE_LIST,
            data: {
                systemCode,
                userId: lib.getParam("userId"),
                check: 1,
            },
            needMask: true,
            success: res => {
                const checkedList = (res || []).filter(item => item.checked === 1);
                setRoleGroup(checkedList);
                setRoleIdList(checkedList.reduce((prev, curr) => [...prev, curr.id], []));
            },
        });
    };

    /**
     * 获取该用户的数据权限
     */
    function fetchData() {
        lib.request({
            url:
                lib.config.webToken === "admin"
                    ? "/ucenter-admin/waiter/data/permission"
                    : "/ucenter-customer/user/sub/data/permission",
            data: {
                systemCode,
                roleIdList: roleIdList,
            },
            needMask: true,
            success: res => {
                let data = res;
                setAccessData(() => {
                    translateData(data);
                    return data;
                });
            },
        });
    }

    function getSystemInfo() {
        lib.request({
            url: "/ucenter-account/current/systemInfo",
            data: {
                systemCode,
            },
            needMask: true,
            success: res => {
                setDetail(res);
            },
        });
    }

    const extraJsonTran = extraJson => {
        if (extraJson) {
            try {
                const extra = JSON.parse(extraJson);
                return extra?.roleNames.join() ?? "";
            } catch (e) {
                return "";
            }
        } else {
            return "";
        }
    };
    return (
        <div className="react-single-app-account-permission-manage">
            <div className={"top"}>
                <div className={"top-left"}>
                    <div className="role-module">
                        <div className="role-img">&#xe706;</div>
                        <Typography.Title level={4}>{lib.getParam("userName")}</Typography.Title>
                    </div>
                </div>
                <div className={"top-right"}>
                    <BindRoleModal
                        userId={lib.getParam("userId")}
                        userName={lib.getParam("userName")}
                        buttonType={"primary"}
                        onSuccess={() => {
                            getUserRoleList();
                        }}
                    />
                </div>
            </div>
            <div className={"content"}>
                <div className={"role-list"}>
                    <div className={"role-list-label"}>角色：</div>
                    <div className={"role-list-content"}>
                        <Tabs
                            defaultValue={allRole}
                            onChange={onChange}
                            tabBarGutter={20}
                            style={{ height: 40 }}
                            size="small"
                            items={items}></Tabs>
                    </div>
                </div>
                <Tabs
                    defaultActiveKey="0"
                    items={[
                        {
                            key: "0",
                            label: "菜单权限",
                            children: (
                                <table>
                                    <thead>
                                        <tr>
                                            <th>一级菜单</th>
                                            <th>二级菜单</th>
                                            {maxLevel > 2 && <th>三级菜单</th>}
                                            <th>按钮</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map((item1, index1) => {
                                            if (!item1.list || item1.list?.length == 0) {
                                                item1.list = [{}];
                                            }
                                            item1.childKeys = getChildKey(item1);
                                            item1.buttonKeys = getChildKey({ list: item1.buttons });
                                            return item1.list.map((item2, index2) => {
                                                if (!item2.list || item2.list?.length == 0) {
                                                    item2.list = [{}];
                                                }
                                                item2.childKeys = getChildKey(item2);
                                                item2.buttonKeys = getChildKey({ list: item2.buttons });
                                                return item2.list.map((item3, index3) => {
                                                    let buttons = item3.buttons || item2.buttons || item1.buttons;
                                                    item3.childKeys = getChildKey(item3);
                                                    item3.buttonKeys = getChildKey({ list: item3.buttons });
                                                    return (
                                                        <tr key={`${index1}-${index2}-${index3}`}>
                                                            {index2 == 0 && index3 == 0 && (
                                                                <td rowSpan={item1.num}>
                                                                    <Tooltip title={extraJsonTran(item1.extraJson)}>
                                                                        {item1.title}
                                                                    </Tooltip>
                                                                </td>
                                                            )}
                                                            {index3 == 0 && (
                                                                <td rowSpan={item2.num}>
                                                                    <Tooltip title={extraJsonTran(item2.extraJson)}>
                                                                        {item2.title}
                                                                    </Tooltip>
                                                                </td>
                                                            )}
                                                            {maxLevel > 2 && (
                                                                <td>
                                                                    <Tooltip title={extraJsonTran(item3.extraJson)}>
                                                                        {item3.title}
                                                                    </Tooltip>
                                                                </td>
                                                            )}
                                                            <td>
                                                                <Space wrap>
                                                                    {" "}
                                                                    {buttons.map((button, index) => (
                                                                        <span key={index}>
                                                                            <Tooltip
                                                                                title={extraJsonTran(button.extraJson)}>
                                                                                {button.title}
                                                                            </Tooltip>
                                                                        </span>
                                                                    ))}
                                                                </Space>
                                                            </td>
                                                        </tr>
                                                    );
                                                });
                                            });
                                        })}
                                    </tbody>
                                </table>
                            ),
                        },
                        {
                            key: "2",
                            label: "数据权限",
                            children: (
                                <AccessData
                                    {...{
                                        accessData,
                                        setAccessData,
                                        systemTarget,
                                        fetchData,
                                    }}
                                />
                            ),
                        },
                    ]}
                />
            </div>
        </div>
    );
}

function translateData(data) {
    data.map(item => {
        item.childKeys = getChildKey(item);
        if (item.list?.length) {
            translateData(item.list);
        }
    });
}

function getTotalLength(data) {
    return data.list.reduce((prev, curr) => (curr.list?.length ? prev + getTotalLength(curr || []) : prev + 1), 0);
}

// 获取所有子节点regionId
function getChildKey(obj) {
    return (
        obj.list?.reduce((prev, curr) => {
            if (curr.id) {
                return prev.concat([curr.id], getChildKey(curr));
            } else {
                return prev.concat(getChildKey(curr));
            }
        }, []) || []
    );
}

function AccessData({ accessData }) {
    // 计算树的最大层级
    const maxLevel = useMemo(() => {
        if (!accessData || accessData.length === 0) return 1;
        let max = 1;
        function calcLevel(items, level = 1) {
            items.forEach(item => {
                max = Math.max(max, level);
                if (item.list && item.list.length > 0 && item.list[0].id) {
                    calcLevel(item.list, level + 1);
                }
            });
        }
        calcLevel(accessData);
        return max;
    }, [accessData]);

    // 动态生成表头
    const tableHeaders = useMemo(() => {
        const headers = [];
        const levelNames = ["一级", "二级", "三级", "四级", "五级", "六级", "七级", "八级", "九级", "十级"];
        for (let i = 0; i < maxLevel; i++) {
            headers.push(`${levelNames[i] || `${i + 1}级`}数据节点`);
        }
        return headers;
    }, [maxLevel]);

    // 将树形数据扁平化为表格行数据
    function flattenTreeToRows(data, level = 1, ancestors = []) {
        const rows = [];

        if (!data || data.length === 0) {
            return rows;
        }

        data.forEach(item => {
            const currentAncestors = [...ancestors, item];

            // 如果是最后一级之前的一级（倒数第二级）
            if (level === maxLevel - 1 && maxLevel > 1) {
                // 获取所有叶子节点（最后一级）
                const leafNodes = item.list && item.list.length > 0 && item.list[0].id ? item.list : [];

                // 创建一行，包含所有祖先节点 + 当前节点 + 平铺的叶子节点
                rows.push({
                    ancestors: ancestors,
                    current: item,
                    leaves: leafNodes,
                    level: level,
                });
            } else if (level < maxLevel - 1) {
                // 继续递归
                const childRows = flattenTreeToRows(item.list || [], level + 1, currentAncestors);
                rows.push(...childRows);
            } else if (level === maxLevel) {
                // 如果已经是最后一级（没有子节点的情况）或者只有一级
                rows.push({
                    ancestors: ancestors,
                    current: item,
                    leaves: [],
                    level: level,
                });
            }
        });

        return rows;
    }

    const flatRows = useMemo(() => flattenTreeToRows(accessData, 1, []), [accessData, maxLevel]);

    return (
        <div className="data-access">
            <table>
                <thead>
                    <tr>
                        {tableHeaders.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {flatRows.map((row, rowIndex) => {
                        return (
                            <tr key={rowIndex}>
                                {/* 渲染所有祖先节点 */}
                                {row.ancestors.map((ancestor, ancestorIndex) => {
                                    // 检查是否应该渲染这个单元格（避免重复）
                                    const shouldRender =
                                        rowIndex === 0 ||
                                        (rowIndex > 0 && flatRows[rowIndex - 1].ancestors[ancestorIndex] !== ancestor);

                                    if (shouldRender) {
                                        // 计算rowSpan：统计后续有多少行共享同一个祖先
                                        let rowSpan = 1;
                                        for (let i = rowIndex + 1; i < flatRows.length; i++) {
                                            if (flatRows[i].ancestors[ancestorIndex] === ancestor) {
                                                rowSpan++;
                                            } else {
                                                break;
                                            }
                                        }

                                        return (
                                            <td key={ancestorIndex} rowSpan={rowSpan}>
                                                {ancestor.name}
                                                {ancestor.remark && (
                                                    <Tooltip title={ancestor.remark}>
                                                        <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                                                    </Tooltip>
                                                )}
                                            </td>
                                        );
                                    }
                                    return null;
                                })}

                                {/* 渲染当前节点（倒数第二级） */}
                                <td>
                                    {row.current.name ? (
                                        <>
                                            {row.current.name}
                                            {row.current.remark && (
                                                <Tooltip title={row.current.remark}>
                                                    <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                                                </Tooltip>
                                            )}
                                        </>
                                    ) : (
                                        "-"
                                    )}
                                </td>

                                {/* 平铺展示最后一级的所有子节点 */}
                                <td>
                                    {row.leaves.length > 0 ? (
                                        <Space wrap>
                                            {row.leaves.map((leaf, leafIndex) => (
                                                <span key={leafIndex}>
                                                    {leaf.name}
                                                    {leaf.remark && (
                                                        <Tooltip title={leaf.remark}>
                                                            <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                                                        </Tooltip>
                                                    )}
                                                    {leafIndex < row.leaves.length - 1 && "、"}
                                                </span>
                                            ))}
                                        </Space>
                                    ) : (
                                        "-"
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default AccountPermissionManage;
